import type { ReactNode } from "react";

interface Props {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  compact?: boolean;
}

export function EmptyState({ icon, title, description, action, compact = false }: Props) {
  return (
    <div className={`flex flex-col items-center justify-center text-center ${compact ? "py-8 px-4" : "py-16 px-6"}`}>
      {icon && (
        <div className={`${compact ? "w-10 h-10 mb-3" : "w-14 h-14 mb-4"} rounded-full bg-surface-muted flex items-center justify-center text-gray-400`}>
          {icon}
        </div>
      )}
      <p className={`font-medium text-gray-700 ${compact ? "text-sm" : "text-base"}`}>{title}</p>
      {description && (
        <p className={`mt-1 text-gray-500 max-w-sm ${compact ? "text-xs" : "text-sm"}`}>{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
